import { connect } from 'react-redux';
import SystemInfo from '../../../features/Admin/SystemInfo/SystemInfo';
import { synchronize, getSystemInfo, getSynchronizationDetails } from '../../../actions/areas/admin';
import globals from '../../../globals/communityGlobals';
import { checkFeatureAccess } from '../../../utils/helpers';

const mapStateToProps = ({ areas: { admin }, global: { auth } }) => {
  const { isSyncDetailsFetching, isSysInfoFetching, sysInfo, syncDetails } = admin.systemInfo;
  return {
    isSysInfoFetching,
    isSyncDetailsFetching,
    sysInfo,
    syncDetails,
    canTriggerSync: checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canTriggerSync),
  };
};

const mapDispatchToProps = dispatch => ({
  handleSynchronize: async (dateFrom, dateTo) => {
    await dispatch(synchronize(dateFrom, dateTo));
    dispatch(getSynchronizationDetails());
  },
  getSysInfo: () => dispatch(getSystemInfo()),
  getSyncDetails: () => dispatch(getSynchronizationDetails()),
});

const SystemInfoPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SystemInfo);

export default SystemInfoPage;
